var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAwesomeUserFriends(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 17.5,
    viewBox: "0 0 25 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-friends",
    "data-name": "Icon awesome-user-friends",
    d: "M7.5,11A4.375,4.375,0,1,0,3.125,6.625,4.373,4.373,0,0,0,7.5,11Zm3,1.25h-.324a6.04,6.04,0,0,1-5.352,0H4.5A4.5,4.5,0,0,0,0,16.75v1.125A1.875,1.875,0,0,0,1.875,19.75h11.25A1.875,1.875,0,0,0,15,17.875V16.75A4.5,4.5,0,0,0,10.5,12.25ZM18.75,11A3.75,3.75,0,1,0,15,7.25,3.751,3.751,0,0,0,18.75,11Zm1.875,1.25h-.148a4.926,4.926,0,0,1-3.453,0h-.148a4.339,4.339,0,0,0-2.176.6,5.717,5.717,0,0,1,1.551,3.9v1.5c0,.086-.02.168-.023.25h6.9A1.875,1.875,0,0,0,25,16.625,4.373,4.373,0,0,0,20.625,12.25Z",
    transform: "translate(0 -2.25)",
    fill: "#446fa2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeUserFriends);
export default __webpack_public_path__ + "static/media/icon-awesome-user-friends.f87739b2b0aa7560aac3bf7c7a087c65.svg";
export { ForwardRef as ReactComponent };